/**
 * @license
 * Copyright Google LLC All Rights Reserved.
 *
 * Use of this source code is governed by an MIT-style license that can be
 * found in the LICENSE file at https://angular.dev/license
 */

// THIS CODE IS GENERATED - DO NOT MODIFY.
const u = undefined;

function plural(val: number): number {
const n = val;

return 5;
}

export default ["tok",[["AM","PM"],u,["pi open suno","pi pini suno"]],[["AM","PM"]],[["S","M","T","W","T","F","S"],["suno esun #7","suno esun #1","suno esun #2","suno esun #3","suno esun #4","suno esun #5","suno esun #6"]],u,[["1","2","3","4","5","6","7","8","9","10","11","12"],["mun #1","mun #2","mun #3","mun #4","mun #5","mun #6","mun #7","mun #8","mun #9","mun #10","mun #11","mun #12"]],u,[["BCE","CE"]],1,[6,0],["y-MM-dd","y MMM d","y MMMM d","y MMMM d, EEEE"],["HH:mm","HH:mm:ss","HH:mm:ss z","HH:mm:ss zzzz"],["{1} {0}",u,u,u],[","," ",";","%","+","-","E","×","‰","∞","NaN",":"],["#,#0.###","%#,#0","¤#,#0.00","#E0"],u,u,u,{"JPY":["JP¥","¥"],"USD":["US$","$"]},"ltr", plural];
